import { useEffect, useState } from 'react';
export function useDesktopLayout() {
    const [isDesktopLayout, setIsDesktopLayout] = useState(() => typeof window === 'undefined' || typeof window.matchMedia !== 'function'
        ? true
        : window.matchMedia('(min-width: 64rem)').matches);
    useEffect(() => {
        if (typeof window.matchMedia !== 'function')
            return;
        const mediaQuery = window.matchMedia('(min-width: 64rem)');
        const updateLayout = () => setIsDesktopLayout(mediaQuery.matches);
        updateLayout();
        mediaQuery.addEventListener('change', updateLayout);
        return () => mediaQuery.removeEventListener('change', updateLayout);
    }, []);
    return isDesktopLayout;
}
